require('./lbCO2Message.scss');

const lbCO2Message = angular.module('app.lbCO2Message', []);

lbCO2Message.component('lbCO2Message', {
  controllerAs: 'vm',
  controller: ['settingsService', controller],
  template: require('./lbCO2Message.html'),
});

function controller(settingsService) {
  let vm = this;
  vm.emissionsAverageDailyKilometers = settingsService.settings.CarConfiguration.EmissionsAverageDailyKilometers;
  vm.message = `CO2 emissions data is based on an average use if ${vm.emissionsAverageDailyKilometers}km per day`;
}

export default lbCO2Message;



// WEBPACK FOOTER //
// ./src/components/lbCO2Message/lbCO2Message.js